import {
  GiChest,
  GiHealthNormal,
  GiCrystalGrowth,
  GiGears,
  GiLotus,
  GiCrossedSwords,
  GiAnvil,
  GiCrownedHeart,
  GiKnapsack,
  GiVortex,
} from 'react-icons/gi';

const ICONS = {
  Recovery: GiHealthNormal,
  Treasure: GiChest,
  'Bonus Relic': GiCrystalGrowth,
  Salvage: GiGears,
  Sanctuary: GiLotus,
  Trial: GiCrossedSwords,
  Armory: GiAnvil,
  Shrine: GiCrownedHeart,
  Supply: GiKnapsack,
  Anomaly: GiVortex,
};

const DoorIcon = ({ kind, className = '' }) => {
  const Icon = ICONS[kind] || GiCrystalGrowth;
  return (
    <Icon
      className={`coreboundDoorIcon ${className}`}
      aria-hidden="true"
      focusable="false"
    />
  );
};

export default DoorIcon;
